<template>
  <div :class="{ 'slide': !show }"  class="scoreboard">
    <div class="main">
      <img
        class="handle"
        v-show="!show"
        @click="slide"
        src="https://vanthink.oss-cn-qingdao.aliyuncs.com/c5f198fc8e7a8a904e392bbbb3b043a7.png" />
      <img
        class="handle"
        v-show="show"
        @click="slide"
        src="https://vanthink.oss-cn-qingdao.aliyuncs.com/57b35892b357c8a335b7929d99d053b5.png" alt="">
      <div class="list-wrapper">
        <div
          class="list"
          :class="[ isGuardMember ? 'guard' : 'offensive' ]">
          <div class="title">
            我的成绩
            <span class="rank">(队伍内排名第{{rank}})</span>
          </div>
          <div class="item">
            <span>{{name}}</span>
            <span>{{score}}</span>
          </div>
        </div>
        <div class="title">攻方</div>
        <div class="list offensive">
          <transition-group name="flip-list">
            <div
              v-for="item in matchInfo.offensive.slice(0, 3)"
              :key="item.id"
              class="item">
              <span>{{item.name}}</span>
              <span>{{item.score}}</span>
            </div>
          </transition-group>
        </div>
        <div class="title">守方</div>
        <div class="list guard">
          <transition-group name="flip-list">
            <div
              v-for="item in matchInfo.guard.slice(0, 3)"
              :key="item.id"
              class="item">
              <span>{{item.name}}</span>
              <span>{{item.score}}</span>
            </div>
          </transition-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/services/utils';

export default {
  props: {
    matchInfo: {
      type: Object,
      default: () => {},
    },
    isGuardMember: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    matchInfo: {
      handler() {
        if (this.isGuardMember) {
          this.list = this.matchInfo.guard;
        } else {
          this.list = this.matchInfo.offensive;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    rank() {
      const { id } = utils.storage('account');
      const rank = utils.Array.findIndex(this.list, { id }, 'id') + 1;

      return rank;
    },
    score() {
      const { id } = utils.storage('account');
      const rank = utils.Array.find(this.list, { id }, 'id');

      return rank.score;
    },
    name() {
      const { name } = utils.storage('account');
      return name;
    },
  },
  data() {
    return {
      show: false,
      list: [],
    };
  },
  methods: {
    slide() {
      this.show = !this.show;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  .scoreboard {
    position: fixed;
    right: 0;
    top: 20%;
    width: 15vw;
    background: #fff;
    border-radius: 20px 0px 0px 20px;
    box-shadow:0px 0px 10px #000;
    transition: transform 1s;
    z-index: 9999;
    .main {
      position: relative;
      width: 100%;
      border-radius: 20px 0px 0px 20px;
      .handle {
        position: absolute;
        top: -60px;
        left: -80px;
        width: 100px;
        z-index: 1;
        cursor: pointer;
      }
      .list-wrapper {
        box-sizing: border-box;
        position: absolute;
        left: 0;
        top: 0;
        padding: 10px;
        width: 100%;
        background: #fff;
        border-radius: 20px 0px 0px 20px;
        overflow: hidden;
        z-index: 2;
        .title {
          font-size: 2.5vh;
          font-weight: 700;
          .rank {
            font-size: 2vh
          }
        }
        .guard {
          .item {
            color: #2843CF;
            background: #ddecfb;
          }
        }
        .offensive {
          .item {
            color: #DE1919;
            background: #ffe4e4;
          }
        }
        .list {
          .item {
            display: flex;
            justify-content: space-between;
            height: 20px;
            margin: 10px 0;
            padding: 10px;
            font-size: 2.2vh;
            border-radius: 10px;
            span:first-child {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
    }
    &.slide {
      transform: translateX(100%);
    }
  }
  .flip-list-move {
    transition: transform 1s;
  }
</style>
